import { useEffect, useState } from 'react';
import axios from 'axios';
import { TopNav } from './TopNav';
import { Footer } from './Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Shared page shell — fetches site settings, renders TopNav + Footer, and
 * wraps page content in the dragon-themed dark background.
 *
 * Use on every public page (Home, PokerRoom, News, Watch, About).
 */
export const PageShell = ({ children, showBackground = true }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings`).then(r => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#0a0a0a' }}>
      <TopNav settings={settings} />
      <main className="flex-1 relative">
        <div className="relative z-10">{children}</div>
      </main>
      <Footer settings={settings} />
    </div>
  );
};
